"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _useDirection3 = _interopRequireDefault(require("../../hooks/useDirection"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ICON_SIZE_FACTOR = 16;

var ErrorNotificationIcon = function ErrorNotificationIcon(_ref) {
  var className = _ref.className,
      size = _ref.size;

  var _useDirection = (0, _useDirection3.default)(),
      _useDirection2 = _slicedToArray(_useDirection, 1),
      direction = _useDirection2[0];

  return _react.default.createElement("svg", {
    alt: "",
    className: (0, _classnames.default)(className + '', direction === 'rtl' && 'webchat__error--rtl'),
    height: ICON_SIZE_FACTOR * size,
    viewBox: "0 0 13.1 13.1",
    width: ICON_SIZE_FACTOR * size
  }, _react.default.createElement("path", {
    d: "M6.5,13C2.9,13,0,10.1,0,6.5S2.9,0,6.5,0S13,2.9,13,6.5S10.1,13,6.5,13z M6.1,3.5v4.3h0.9V3.5H6.1z M6.1,8.7v0.9h0.9V8.7H6.1z",
    fillRule: "evenodd"
  }));
};

ErrorNotificationIcon.defaultProps = {
  className: '',
  size: 1
};
ErrorNotificationIcon.propTypes = {
  className: _propTypes.default.string,
  size: _propTypes.default.number
};
var _default = ErrorNotificationIcon;
exports.default = _default;